import { providerType } from '@repo/shared/types';
import { isAvailableMultiProvider } from './is-available-multiprovider-provider';
import { isLiberisPromoted } from './is-liberis-promoted';
import { isPragmaPromoted } from './is-pragma-promoted';
export function deriveFlowType(merchantResponseData) {
    var providers = merchantResponseData.currentProvider;
    if (isAvailableMultiProvider(merchantResponseData))
        return 'multiprovider';
    if (providers.length === 1) {
        if (providers[0] === providerType.enum.pragma)
            return 'onlyPragma';
        if (providers[0] === providerType.enum.liberis)
            return 'onlyLiberis';
    }
    if (isPragmaPromoted(merchantResponseData))
        return 'defaultPragma';
    if (isLiberisPromoted(merchantResponseData))
        return 'defaultLiberis';
    return 'onlyPragma';
}
